import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router';
import { Card, Button, Alert } from 'react-bootstrap';
import { FaArrowLeft, FaEdit } from 'react-icons/fa';
import { useIncidentActions } from './hooks/incidentActionHooks';
import ActionDetailsBody from './ActionDetailsBody';
import ActionDrawer from './ActionDrawer';
import { INCIDENT } from './ICSConstants';
import Loading from '../Loading/Loading';
import PageTitle from '../headers/PageTitle';

const ActionView: React.FC = () => {
  const { incidentId, actionId } = useParams<{
    incidentId: string;
    actionId: string;
  }>();
  const navigate = useNavigate();
  const [showEditDrawer, setShowEditDrawer] = useState(false);
  const { data: actions, isLoading } = useIncidentActions();

  // Find the specific action
  const action = actions?.find((a) => a.action_id === actionId);

  // Navigate back to the previous view (table or kanban)
  const handleBack = () => {
    // Check if we came from a specific view
    const referrer = document.referrer;
    const currentPath = `/iap/${incidentId}/actions`;

    if (referrer.includes(currentPath)) {
      // Go back to the previous page
      navigate(-1);
    } else {
      // Default to actions page (will use stored view preference)
      navigate(`/iap/${incidentId}/actions`);
    }
  };

  if (isLoading) {
    return <Loading />;
  }

  if (!action) {
    return (
      <div className="maincontent">
        <Alert variant="warning">
          <h4>Action Not Found</h4>
          <p>The requested action could not be found.</p>
          <Button variant="primary" onClick={handleBack}>
            <FaArrowLeft className="me-2" />
            Back to Actions
          </Button>
        </Alert>
      </div>
    );
  }

  return (
    <div className="maincontent">
      <PageTitle title={action.name} onBack={handleBack}>
        <div className="d-flex gap-2">
          <Button variant="outline-secondary" onClick={handleBack}>
            <FaArrowLeft className="me-2" />
            Back to Actions
          </Button>
          <Button variant="primary" onClick={() => setShowEditDrawer(true)}>
            <FaEdit className="me-2" />
            Edit Action
          </Button>
        </div>
      </PageTitle>

      <Card
        style={{
          backgroundColor: 'var(--background-dark)',
          border: '1px solid var(--border-neutral)',
        }}
      >
        <Card.Header
          style={{
            backgroundColor: 'var(--background-light)',
            borderBottom: '1px solid var(--border-neutral)',
          }}
        >
          <h5 className="mb-0 text-white">Action Details</h5>
        </Card.Header>
        <Card.Body>
          <ActionDetailsBody action={action} />
        </Card.Body>
      </Card>

      {showEditDrawer && (
        <ActionDrawer
          scope={INCIDENT}
          toggle={() => setShowEditDrawer(false)}
          selectedEntity={action}
        />
      )}
    </div>
  );
};

export default ActionView;
